export default __webpack_public_path__ + "static/media/icon-business-model-transactional.eea1dc59.svg";